"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.display = void 0;
const chalk = require("chalk");
const debug_1 = require("../debug");
const dep_graph_1 = require("@snyk/dep-graph");
const display_1 = require("./display");
async function display(scanResults, testResults, errors, options) {
    try {
        const result = [];
        if (options === null || options === void 0 ? void 0 : options.path) {
            const prefix = chalk.bold.white(`\nTesting ${options.path}...\n`);
            result.push(prefix);
        }
        if (options === null || options === void 0 ? void 0 : options.debug) {
            const signatureLines = display_1.displaySignatures(scanResults);
            result.push(...signatureLines);
        }
        for (const testResult of testResults) {
            const depGraph = dep_graph_1.createFromJSON(testResult.depGraphData);
            const [dependencySection, issuesSection] = display_1.selectDisplayStrategy(options, depGraph, testResult);
            result.push(...dependencySection, ...issuesSection);
        }
        const errorLines = display_1.displayErrors(errors);
        result.push(...errorLines);
        return result.join('\n');
    }
    catch (error) {
        debug_1.debug(error.message || 'Error displaying results. ' + error);
        return 'Error displaying results.';
    }
}
exports.display = display;
//# sourceMappingURL=index.js.map